<template>
  <div>
    <div class="pc_all GenerateManagement LogoFile">
      <div class="GenerateManagementContent">
        <div class="GenerateManagementContent_nav">
          <div class="GenerateManagementContent_nav_left">
            <div class="nav_left_dd font20">样机展示</div>
            <div class="nav_left_dt font14">
              全部原创设计，线上/线下全渠道，皆可商用。支持下载JPG、PNG和SVG源文件等格式
            </div>
          </div>
          <div class="GenerateManagementContent_nav_share">
            分享<img alt="" src="@a/ailogo/images/sv14.svg"/>
          </div>
        </div>
        <div class="GenerateManagementContent_txt">
          <div class="GenerateManagementContent_txt_scroll OScroll">
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li">
                  <!--                  <img alt="" src="@a/ailogo/images/case/1.jpg"/>-->
                  <svg id="advertising" data-name="图层 1"
                       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                       viewBox="0 0 814 509">
                    <image width="814" height="509" xlink:href="@a/ailogo/images/case/1.jpg"/>
                    <rect x="142" y="141" width="522" height="246" :style="{ fill: background, strokeWidth: '0px' , opacity: '0.8'}" />
                    <image x="142" y="141" width="522" height="246" :xlink:href="picturesAndTexts"/>
                  </svg>
                  <!--                  <canvas ref="canvas1" width="814" height="509"></canvas>-->
                </div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">户外广告展示效果</div>
                  <div class="title_left_dt font14">下载文件格式：PNG/JPG</div>
                </div>
                <div class="list_title_icon font16" @click="downloadAsPNG('advertising')">
                  <img alt="" src="@a/ailogo/images/sv3_1.svg" />下载
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li">
                  <svg id="_图层_1" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 814 509">
                    <defs>
                    </defs>
                    <image width="814" height="509" xlink:href="@a/ailogo/images/case/14.jpg"/>
                    <path :style="{ fill: background, strokeWidth: '0px', opacity: '0.6' }" d="M365.5,71.9l2.4.9,4.8,1s4.7.9,5.1.9,3.9.2,4,.2h3.7c.2,0,3.2,0,3.5,0s4.1,0,4.3,0,10-.6,10-.6c0,0,6.3-.3,6.5-.4s8.2-2,8.4-2,7.2-3.3,7.2-3.3l3.7-3,3.1-3.3,1.2-2.5s-.2-1.3-.2-1.6,0-1.4,0-1.4c0,0,4.3-.4,5-.3s4.1,2.2,4.3,2.3,1,0,2,.8,4.7,1.9,5.2,2.1,1.8.9,2.2,1.1,2.1.9,2.6,1.2,1.8.8,2,.9,1.3,1.1,1.6,1.4,1.6,1.1,2.1,1.4,6.3,3.5,6.5,3.6,3.2,2,3.2,2l4.4,1.5s2.6,1.1,2.9,1.3,2.9.8,2.9.8c0,0,2.9,1.1,3.3,1.2s13.9,5.4,13.9,5.4c0,0,3.1.7,3.7.9s3.2,1.1,4,1.4,2.4.8,3.3,1.2,3.4,1.3,3.4,1.3c0,0,2.4.9,3.7,1.5s4.6,1.6,5.1,1.8,2.6,1,2.7,1.1,1.4.8,1.9,1.2,2,2.2,2,2.2l1.3,1.3,2.3,1.8,8.4,6.8s1.3,1.7,1.7,2,2,1.8,3.1,2.7,6,5.7,6,5.7l1.8,1.5,6.3,5.4,1.9,1.4,1.6,1.5,14,8,3,2.3s9.2,6.2,9.4,6.3,7.8,7.1,7.8,7.1l6.6,6,4.8,4.9,3.2,3.1s2.1,3.4,2.1,3.6.3,1.4.3,1.4v1.9s-1.9,1.3-1.9,1.3l-1.9,2-.6.6-.3.4-.3.5s-2.4,2.8-2.8,3.4-4.8,5.8-5,6-.8.9-1.1,1.5-.8,1.3-.8,1.3l-.8,1.1s-.9.7-1,.9-.4.7-.7,1.2-1,1.4-1.1,1.7-.3.6-.5,1-.6,1-.6,1l-5.1,9.3-4,6.4s-2.7,3.9-2.9,4.1-6.2,9.1-6.2,9.1l-3,3.9s-2.3,2.9-2.5,3-2.2,3.5-2.2,3.5l-2.3,2.1-.8,1.2-.8,1.5s-2.4.7-2.6.7-2.1-.3-2.5-.4-3-1-3.4-1.2-2.6-.9-2.6-.9l-3.6-1.5-3-.9-5.1-1.6s-3.8-1.1-5-1.4-3.5-1.2-4.2-1.4-2.2-.6-2.6-.7-2.5-.9-3.1-1.1-2.1-.5-2.5-.5-1.9-.3-2.1-.3-1,0-1.6.3-.8.2-1,.6-.5.9-.6,1.4-.5,1.9-.5,1.9c0,0,0,1.5,0,1.9s.2.7.2,1.3.2,1.6.3,2,.2.9.2,1.2,0,1,0,1c0,0,.2.9.2,1.3v.8l1.8,23.6.8,39.7v37.8c0,0,.1,51.6.1,51.6l1.1,31.5s-.6,4-.6,4.2.2,4.2.2,5-.2,3.4-.2,4.1v4.8l-.7,1.5-.6.9h-4.7c0,0-78.4.6-78.4.6l-98.7,1.2-25.3-1s-9.2-1.7-9.5-1.7-4.2-.7-4.2-.7h-5.5l-5.3.4s-6.7-.3-8.7-.1-5.4,0-7.8,0h-7.2l-2-.2-2.4-.5.7-5.8.4-1.3.7-4.5.5-2.6c.1-.7.7-7.3.7-7.3,0,0-.8-4.8-.8-5.1s-.3-4-.3-4l-.9-3.7-.4-2.3v-2.4l.4-55.5,2-80.2-1.2-26.2s.4-3.6.5-4-.3-3.3-.3-3.3c0,0,0-1.7,0-2s-.2-1.8-.4-2.3-1-1.3-1-1.3l-2.2-1.2h-2.5c-.9,0-6.6,1.7-6.6,1.7,0,0-4,1.5-4.9,2s-.4.3-2.4,1.3-1.4,1-3.9,1.5-3.4.1-4.6.5,1.8-1-1.5.7-4.9,2.5-7.5,3.1-6.1.8-6.1.8l-2.1-1.6-3-6.4-12.7-21.1-16.5-22.8-11.9-19-4.5-6.9-.7-2.4,1-1.5,3.7-3.2,19.2-9.6,19.2-12.1,19.3-12,17.8-12.3,14.1-11.9,21.7-14.2,20.2-8.6,17-6.8,15.1-6,5-2.6,1.8-.9,9.3,10,13.8,2.9Z"/>
                    <image x="312" y="161" width="170" height="146" :xlink:href="croppedImage"/>
                  </svg>
                </div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">服装展示效果</div>
                  <div class="title_left_dt font14">下载文件格式：PNG/JPG</div>
                </div>
                <div class="list_title_icon font16">
                  <img alt="" src="@a/ailogo/images/sv3_1.svg"/>下载
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li">
                  <svg id="company" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 814 509">
                    <defs>
                    </defs>
                    <image width="814" height="509" xlink:href="@a/ailogo/images/case/13.jpg"/>
                    <path :style="{ fill: background, strokeWidth: '0px' , opacity: '0.6'}"  d="M493.8,208.1c-1.2-7.1-10.5-9.1-10.5-9.1l-57.3.8v10.2c-1.8,12.8-6.7,14.8-6.7,14.8h-8.1c-3.6-.7-4.1-7.5-4.1-7.5,3.2,1.3,7.8-1.4,7.8-1.4l.3-16-63.3.9-4.4.2c-9.8,1.9-9.7,11.7-9.7,11.7l2.3,221.4c1.5,7.3,9.4,9.5,9.4,9.5h136.2c10.5-1.8,10.7-9.8,10.7-9.8l-2.5-225.9Z"/>
                    <image x="350" y="271" width="140" height="86" :xlink:href="croppedImage"/>
                    <image x="400" y="35" width="28" height="26" :xlink:href="croppedImage"/>
                    <image x="400" y="73" width="28" height="26" :xlink:href="croppedImage"/>
                    <image x="400" y="110" width="28" height="26" :xlink:href="croppedImage"/>
                  </svg>
                </div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">公司胸牌展示效果</div>
                  <div class="title_left_dt font14">下载文件格式：PNG/JPG</div>
                </div>
                <div class="list_title_icon font16" @click="downloadAsPNG('company')">
                  <img alt="" src="@a/ailogo/images/sv3_1.svg"/>下载
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li">
                  <svg id="cosmetic" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 814 509">
                    <defs>
                    </defs>
                    <image width="814" height="509" xlink:href="@a/ailogo/images/case/12.jpg"/>
                    <path :style="{ fill: background, strokeWidth: '0px'  , opacity: '0.5'}" d="M373.3,146.7s-41.2,2.3-48.2,11.3l-.2,270.5s2.1,2.5,5.2,2.3h157.3s5.4-1.9,5.3-4.3V158.2s-2.2-5.1-11.6-5.8l-37-5.6h-70.8Z"/>
                    <image x="330" y="231" width="160" height="90" :xlink:href="croppedImage"/>
                  </svg>
                </div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">化妆品展示效果</div>
                  <div class="title_left_dt font14">下载文件格式：PNG/JPG</div>
                </div>
                <div class="list_title_icon font16" @click="downloadAsPNG('cosmetic')">
                  <img alt="" src="@a/ailogo/images/sv3_1.svg"/>下载
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li">
                  <svg id="reticule" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 814 509">
                    <defs>
                    </defs>
                    <image width="814" height="509" xlink:href="@a/ailogo/images/case/10.jpg"/>
                    <polygon :style="{ fill: background, strokeWidth: '0px' , opacity: '0.6'}" points="275.6 133.4 261.7 448.1 463.3 465.1 509.4 455.2 509.4 454 499.3 131.9 478 132.1 477.9 130 275.6 133.4"/>
                    <image x="290" y="241" width="160" height="106" style="transform-origin: right bottom; transform: skew(360deg) rotate(3deg) translate3d(-7px, 31px, 10px);" :xlink:href="croppedImage"/>
                  </svg>
                </div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">手提袋展示效果</div>
                  <div class="title_left_dt font14">下载文件格式：PNG/JPG</div>
                </div>
                <div class="list_title_icon font16" @click="downloadAsPNG('reticule')">
                  <img alt="" src="@a/ailogo/images/sv3_1.svg"/>下载
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li">
                  <svg id="rollup" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 814 509">
                    <defs>
                    </defs>
                    <image width="814" height="509" xlink:href="@a/ailogo/images/case/6.jpg"/>
                    <polygon :style="{ fill: background, strokeWidth: '0px' , opacity: '0.6'}" points="254.4 35.7 560.3 36 559.9 461 252.4 461 254 35.7 254.4 35.7"/>
                    <image x="272" y="151" width="280" height="166" :xlink:href="croppedImage"/>
                  </svg>
                </div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">企宣易拉宝展示效果</div>
                  <div class="title_left_dt font14">下载文件格式：PNG/JPG</div>
                </div>
                <div class="list_title_icon font16" @click="downloadAsPNG('rollup')">
                  <img alt="" src="@a/ailogo/images/sv3_1.svg"/>下载
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li">
                  <svg id="lightbox" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 814 509">
                    <defs>
                    </defs>
                    <image width="814" height="509" xlink:href="@a/ailogo/images/case/7.jpg"/>
                    <path :style="{ fill: background, strokeWidth: '0px' , opacity: '0.8',}" d="M585.1,176.9l-7-2.5-29.7,17.4,1,18-19.9-1.4-.7-48.3-1.8-5.9-2.6-4.4-5.4-6.8-5.9-4.5-4.5-1.7-186.1-31.3s-11.3-.2-11.4-.2-4,1.4-4,1.4l-5.9,3.1-7,7.1-27.7,29.1v.4s-1.1,3.5-1.1,3.5l-6.7,210.7,1.6,4.8s1.5,3.6,1.7,3.9c.2.3,2.3,2.7,2.3,2.7l3.4,3.6,2.2,1.9,3.2,2.3,5.3,2.3,24.4,1.8,175.2,12.5,20.4-6.4,18.3-7.3s5-1.9,5.3-2c.3,0,2.3-2,2.3-2,0,0,3.8-2.6,4.3-3.2.5-.6,1.1-2.6,1.3-2.9s1.1-3.6,1.1-3.6l1.4-5,.3-32.8,21.3.2,1,46.1,13.7,1.2,22.7-6.1-6.1-195.8ZM531,312.2l-2.1-85.2h.4l20.6,1.6,2,85-21-1.5Z"/>
                    <image x="320" y="161" width="180" height="146" style="transform-origin:bottom right;transform:skew(360deg) rotate(6deg) translate3d(-17px, 52px, 10px);" :xlink:href="croppedImage"/>
                  </svg>
                </div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">灯箱店招展示效果</div>
                  <div class="title_left_dt font14">下载文件格式：PNG/JPG</div>
                </div>
                <div class="list_title_icon font16" @click="downloadAsPNG('lightbox')">
                  <img alt="" src="@a/ailogo/images/sv3_1.svg"/>下载
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li">
                  <svg id="door" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 814 509">
                    <defs>
                    </defs>
                    <image width="814" height="509" xlink:href="@a/ailogo/images/case/11.jpg"/>
                    <path :style="{ fill: background, strokeWidth: '0px'  , opacity: '0.8'}" d="M355.9,80.5l6.1-5.6,6.4-3.8,6.7-2.6,7.6-3.2,11.4-2.9s52.4-7.9,91.2-1.7c0,0,51.3,6.8,107.1,40.4l2,316.5h-19.2l-72.3-11.5-12.1-1.3-15.7-.6-24.1-1.4-40.8.6-30.6,1.4-20.3,2.7-6.4,2.1-3.5,1.8,6.5-331Z"/>
                    <image x="375" y="151" width="200" height="146" :xlink:href="croppedImage"/>
                    <image x="180" y="231" width="60" height="40" style="transform-origin:bottom right;transform:skew(-366deg) rotate(-3deg) translate3d(-94px, 3px, 10px);" :xlink:href="croppedImage"/>
                  </svg>
                </div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">实体门店门头展示效果</div>
                  <div class="title_left_dt font14">下载文件格式：PNG/JPG</div>
                </div>
                <div class="list_title_icon font16" @click="downloadAsPNG('door')">
                  <img alt="" src="@a/ailogo/images/sv3_1.svg"/>下载
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {fabric} from 'fabric'
export default {
  props: {
    picturesAndTextsWithBackground: null,
    // canvas: null,
    independentPatternWithBackground: null,
    picturesAndTexts: null,
    independentPattern: null,
    svgBaseUrl: null,
    croppedImage: null,
    background: null,
    title:null,
    // canvasWidth: 1200,
    // canvasHeight: 900,
  },
  data() {
    return {
      GenerateManagementWindowActive: false
    }
  },
  methods: {
    downloadAsPNG(svgId) {
      // 获取 SVG 元素
      const svgElement = document.getElementById(svgId);

      if (!svgElement) {
        console.error('SVG 元素未找到');
        return;
      }

      // 将 SVG 转换为字符串
      const svgString = new XMLSerializer().serializeToString(svgElement);

      // 使用 fabric.js 创建一个新的 canvas
      const canvas = new fabric.Canvas(document.createElement('canvas'));

      // 使用 fabric.js 加载 SVG 数据
      fabric.loadSVGFromString(svgString, (objects, options) => {
        const group = fabric.util.groupSVGElements(objects, options);

        // 将 SVG 添加到 canvas 中
        canvas.add(group);

        // 设定 canvas 尺寸与 SVG 相同
        canvas.setWidth(group.width);
        canvas.setHeight(group.height);

        // 使用 fabric.js 将 canvas 转换为 PNG 数据 URL
        const dataURL = canvas.toDataURL({ format: 'png' });

        // 创建下载链接
        const link = document.createElement('a');
        link.href = dataURL;
        link.download = `${this.title}.png`; // 使用 SVG 的 ID 作为文件名

        // 触发点击下载
        link.click();
      });
    },
  },
}
</script>


<style>
@import "GenerateManagement.css";
</style>
